/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function PaidMember({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} clipPath="url(#PaidMember_svg__a)"><path d="M15 8a7 7 0 1 1-7-7" /><path d="M10.358 6.097v0a.697.697 0 0 0-.697-.697h-3.02a1 1 0 0 0-1 1V7a1 1 0 0 0 1 1H8M5.642 9.903v0c0 .385.312.697.696.697h3.02a1 1 0 0 0 1-1v-.599a1 1 0 0 0-1-1H8M8 3.469v9.062M11.364 2.667 13.182 1 15 2.667M13.182 4.868V1.5" /></g><defs><clipPath id="PaidMember_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;